export const leadTypeList = [
  { value: "Package", label: "Package" },
  { value: "Flight", label: "Flight" },
  { value: "Hotel", label: "Hotel" },
  { value: "Activity", label: "Activity" },
  { value: "Transfers", label: "Transfers" },
  { value: "Visa", label: "Visa" },
  { value: "Rail", label: "Rail" },
  { value: "Forex", label: "Forex" },
  { value: "Bus", label: "Bus" },
  { value: "Rent a Car", label: "Rent a Car" },
];

export const tripTypeList = [
  { value: "Domestic", label: "Domestic" },
  { value: "International", label: "International" },
  { value: "Both", label: "Both" },
];

export const leadSourceList = [
  { value: "Call Center", label: "Call Center" },
  { value: "Walkin", label: "Walkin" },
  { value: "Email", label: "Email" },
  { value: "Referred By", label: "Referred By" },
  { value: "Social Media", label: "Social Media" },
];

export const leadStatusList = [
  { value: "New", label: "New" },
  { value: "Open", label: "Open" },
  { value: "Completed", label: "Completed" },
  { value: "Expired", label: "Expired" },
  { value: "Closed", label: "Closed" },
  { value: "Proposal", label: "Proposal" },
  { value: "Other", label: "Other" },
];

export const genderList = [
  { value: "Male", name: "Male" },
  { value: "Female", name: "Female" },
];

export const documentTypeList = [
  { value: "Adhar", name: "Adhar" },
  { value: "Passport", name: "Passport" },
];

export const countryList = [
  {
    value: "AF_93",
    name: "Afghanistan",
    isoCode: "AF",
    countryCode: "93",
  },
  {
    value: "AL_355",
    name: "Albania",
    isoCode: "AL",
    countryCode: "355",
  },
  {
    value: "DZ_213",
    name: "Algeria",
    isoCode: "DZ",
    countryCode: "213",
  },
  {
    value: "AS_1684",
    name: "American Samoa",
    isoCode: "AS",
    countryCode: "1684",
  },
  {
    value: "AD_376",
    name: "Andorra",
    isoCode: "AD",
    countryCode: "376",
  },
  {
    value: "AO_244",
    name: "Angola",
    isoCode: "AO",
    countryCode: "244",
  },
  {
    value: "AI_1264",
    name: "Anguilla",
    isoCode: "AI",
    countryCode: "1264",
  },
  {
    value: "AQ_672",
    name: "Antarctica",
    isoCode: "AQ",
    countryCode: "672",
  },
  {
    value: "AG_1268",
    name: "Antigua and Barbuda",
    isoCode: "AG",
    countryCode: "1268",
  },
  {
    value: "AR_54",
    name: "Argentina",
    isoCode: "AR",
    countryCode: "54",
  },
  {
    value: "AM_374",
    name: "Armenia",
    isoCode: "AM",
    countryCode: "374",
  },
  {
    value: "AW_297",
    name: "Aruba",
    isoCode: "AW",
    countryCode: "297",
  },
  {
    value: "AU_61",
    name: "Australia",
    isoCode: "AU",
    countryCode: "61",
  },
  {
    value: "AT_43",
    name: "Austria",
    isoCode: "AT",
    countryCode: "43",
  },
  {
    value: "AZ_994",
    name: "Azerbaijan",
    isoCode: "AZ",
    countryCode: "994",
  },
  {
    value: "BS_1242",
    name: "Bahamas",
    isoCode: "BS",
    countryCode: "1242",
  },
  {
    value: "BH_973",
    name: "Bahrain",
    isoCode: "BH",
    countryCode: "973",
  },
  {
    value: "BD_880",
    name: "Bangladesh",
    isoCode: "BD",
    countryCode: "880",
  },
  {
    value: "BB_1246",
    name: "Barbados",
    isoCode: "BB",
    countryCode: "1246",
  },
  {
    value: "BY_375",
    name: "Belarus",
    isoCode: "BY",
    countryCode: "375",
  },
  {
    value: "BE_32",
    name: "Belgium",
    isoCode: "BE",
    countryCode: "32",
  },
  {
    value: "BZ_501",
    name: "Belize",
    isoCode: "BZ",
    countryCode: "501",
  },
  {
    value: "BJ_229",
    name: "Benin",
    isoCode: "BJ",
    countryCode: "229",
  },
  {
    value: "BM_1441",
    name: "Bermuda",
    isoCode: "BM",
    countryCode: "1441",
  },
  {
    value: "BT_975",
    name: "Bhutan",
    isoCode: "BT",
    countryCode: "975",
  },
  {
    value: "BO_591",
    name: "Bolivia",
    isoCode: "BO",
    countryCode: "591",
  },
  {
    value: "BA_387",
    name: "Bosnia and Herzegovina",
    isoCode: "BA",
    countryCode: "387",
  },
  {
    value: "BW_267",
    name: "Botswana",
    isoCode: "BW",
    countryCode: "267",
  },
  {
    value: "BR_55",
    name: "Brazil",
    isoCode: "BR",
    countryCode: "55",
  },
  {
    value: "IO_246",
    name: "British Ocean Territory",
    isoCode: "IO",
    countryCode: "246",
  },
  {
    value: "VG_1284",
    name: "British Virgin Islands",
    isoCode: "VG",
    countryCode: "1284",
  },
  {
    value: "BN_673",
    name: "Brunei",
    isoCode: "BN",
    countryCode: "673",
  },
  {
    value: "BG_359",
    name: "Bulgaria",
    isoCode: "BG",
    countryCode: "359",
  },
  {
    value: "BF_226",
    name: "Burkina Faso",
    isoCode: "BF",
    countryCode: "226",
  },
  {
    value: "BI_257",
    name: "Burundi",
    isoCode: "BI",
    countryCode: "257",
  },
  {
    value: "KH_855",
    name: "Cambodia",
    isoCode: "KH",
    countryCode: "855",
  },
  {
    value: "CM_237",
    name: "Cameroon",
    isoCode: "CM",
    countryCode: "237",
  },
  {
    value: "US_1",
    name: "United States",
    isoCode: "US",
    countryCode: "1",
  },
  {
    value: "CA_1",
    name: "Canada",
    isoCode: "CA",
    countryCode: "1",
  },
  {
    value: "CV_238",
    name: "Cape Verde",
    isoCode: "CV",
    countryCode: "238",
  },
  {
    value: "KY_1345",
    name: "Cayman Islands",
    isoCode: "KY",
    countryCode: "1345",
  },
  {
    value: "CF_236",
    name: "Central African Republic",
    isoCode: "CF",
    countryCode: "236",
  },
  {
    value: "TD_235",
    name: "Chad",
    isoCode: "TD",
    countryCode: "235",
  },
  {
    value: "CL_56",
    name: "Chile",
    isoCode: "CL",
    countryCode: "56",
  },
  {
    value: "CN_86",
    name: "China",
    isoCode: "CN",
    countryCode: "86",
  },
  {
    value: "CX_61",
    name: "Christmas Island",
    isoCode: "CX",
    countryCode: "61",
  },
  {
    value: "CC_61",
    name: "Cocos Islands",
    isoCode: "CC",
    countryCode: "61",
  },
  {
    value: "CO_57",
    name: "Colombia",
    isoCode: "CO",
    countryCode: "57",
  },
  {
    value: "KM_269",
    name: "Comoros",
    isoCode: "KM",
    countryCode: "269",
  },
  {
    value: "CK_682",
    name: "Cook Islands",
    isoCode: "CK",
    countryCode: "682",
  },
  {
    value: "CR_506",
    name: "Costa Rica",
    isoCode: "CR",
    countryCode: "506",
  },
  {
    value: "HR_385",
    name: "Croatia",
    isoCode: "HR",
    countryCode: "385",
  },
  {
    value: "CU_53",
    name: "Cuba",
    isoCode: "CU",
    countryCode: "53",
  },
  {
    value: "CW_599",
    name: "Curacao",
    isoCode: "CW",
    countryCode: "599",
  },
  {
    value: "CY_357",
    name: "Cyprus",
    isoCode: "CY",
    countryCode: "357",
  },
  {
    value: "CZ_420",
    name: "Czech Republic",
    isoCode: "CZ",
    countryCode: "420",
  },
  {
    value: "CD_243",
    name: "Democratic Republic of the Congo",
    isoCode: "CD",
    countryCode: "243",
  },
  {
    value: "DK_45",
    name: "Denmark",
    isoCode: "DK",
    countryCode: "45",
  },
  {
    value: "DJ_253",
    name: "Djibouti",
    isoCode: "DJ",
    countryCode: "253",
  },
  {
    value: "DM_1767",
    name: "Dominica",
    isoCode: "DM",
    countryCode: "1767",
  },
  {
    value: "DO_1809",
    name: "Dominican Republic",
    isoCode: "DO",
    countryCode: "1809",
  },
  {
    value: "TL_670",
    name: "East Timor",
    isoCode: "TL",
    countryCode: "670",
  },
  {
    value: "EC_593",
    name: "Ecuador",
    isoCode: "EC",
    countryCode: "593",
  },
  {
    value: "EG_20",
    name: "Egypt",
    isoCode: "EG",
    countryCode: "20",
  },
  {
    value: "IL_20",
    name: "Israel",
    isoCode: "IL",
    countryCode: "972",
  },
  {
    value: "SV_503",
    name: "El Salvador",
    isoCode: "SV",
    countryCode: "503",
  },
  {
    value: "GQ_240",
    name: "Equatorial Guinea",
    isoCode: "GQ",
    countryCode: "240",
  },
  {
    value: "ER_291",
    name: "Eritrea",
    isoCode: "ER",
    countryCode: "291",
  },
  {
    value: "EE_372",
    name: "Estonia",
    isoCode: "EE",
    countryCode: "372",
  },
  {
    value: "ET_251",
    name: "Ethiopia",
    isoCode: "ET",
    countryCode: "251",
  },
  {
    value: "FK_500",
    name: "Falkland Islands",
    isoCode: "FK",
    countryCode: "500",
  },
  {
    value: "FO_298",
    name: "Faroe Islands",
    isoCode: "FO",
    countryCode: "298",
  },
  {
    value: "FJ_679",
    name: "Fiji",
    isoCode: "FJ",
    countryCode: "679",
  },
  {
    value: "FI_358",
    name: "Finland",
    isoCode: "FI",
    countryCode: "358",
  },
  {
    value: "FR_33",
    name: "France",
    isoCode: "FR",
    countryCode: "33",
  },
  {
    value: "PF_689",
    name: "French Polynesia",
    isoCode: "PF",
    countryCode: "689",
  },
  {
    value: "GA_241",
    name: "Gabon",
    isoCode: "GA",
    countryCode: "241",
  },
  {
    value: "GM_220",
    name: "Gambia",
    isoCode: "GM",
    countryCode: "220",
  },
  {
    value: "GE_995",
    name: "Georgia",
    isoCode: "GE",
    countryCode: "995",
  },
  {
    value: "DE_49",
    name: "Germany",
    isoCode: "DE",
    countryCode: "49",
  },
  {
    value: "GH_233",
    name: "Ghana",
    isoCode: "GH",
    countryCode: "233",
  },
  {
    value: "GI_350",
    name: "Gibraltar",
    isoCode: "GI",
    countryCode: "350",
  },
  {
    value: "GR_30",
    name: "Greece",
    isoCode: "GR",
    countryCode: "30",
  },
  {
    value: "GL_299",
    name: "Greenland",
    isoCode: "GL",
    countryCode: "299",
  },
  {
    value: "GD_1473",
    name: "Grenada",
    isoCode: "GD",
    countryCode: "1473",
  },
  {
    value: "GU_1671",
    name: "Guam",
    isoCode: "GU",
    countryCode: "1671",
  },
  {
    value: "GT_502",
    name: "Guatemala",
    isoCode: "GT",
    countryCode: "502",
  },
  {
    value: "GG_441481",
    name: "Guernsey",
    isoCode: "GG",
    countryCode: "441481",
  },
  {
    value: "GN_224",
    name: "Guinea",
    isoCode: "GN",
    countryCode: "224",
  },
  {
    value: "GW_245",
    name: "Guinea-Bissau",
    isoCode: "GW",
    countryCode: "245",
  },
  {
    value: "GY_592",
    name: "Guyana",
    isoCode: "GY",
    countryCode: "592",
  },
  {
    value: "HT_509",
    name: "Haiti",
    isoCode: "HT",
    countryCode: "509",
  },
  {
    value: "HN_504",
    name: "Honduras",
    isoCode: "HN",
    countryCode: "504",
  },
  {
    value: "HK_852",
    name: "Hong Kong",
    isoCode: "HK",
    countryCode: "852",
  },
  {
    value: "HU_36",
    name: "Hungary",
    isoCode: "HU",
    countryCode: "36",
  },
  {
    value: "IS_354",
    name: "Iceland",
    isoCode: "IS",
    countryCode: "354",
  },
  {
    value: "IN_91",
    name: "India",
    isoCode: "IN",
    countryCode: "91",
  },
  {
    value: "ID_62",
    name: "Indonesia",
    isoCode: "ID",
    countryCode: "62",
  },
  {
    value: "IR_98",
    name: "Iran",
    isoCode: "IR",
    countryCode: "98",
  },
  {
    value: "IQ_964",
    name: "Iraq",
    isoCode: "IQ",
    countryCode: "964",
  },
  {
    value: "IE_353",
    name: "Ireland",
    isoCode: "IE",
    countryCode: "353",
  },
  {
    value: "IM_441624",
    name: "Isle of Man",
    isoCode: "IM",
    countryCode: "441624",
  },
  {
    value: "IT_39",
    name: "Italy",
    isoCode: "IT",
    countryCode: "39",
  },
  {
    value: "CI_225",
    name: "Ivory Coast",
    isoCode: "CI",
    countryCode: "225",
  },
  {
    value: "JM_1876",
    name: "Jamaica",
    isoCode: "JM",
    countryCode: "1876",
  },
  {
    value: "JP_81",
    name: "Japan",
    isoCode: "JP",
    countryCode: "81",
  },
  {
    value: "JE_441534",
    name: "Jersey",
    isoCode: "JE",
    countryCode: "441534",
  },
  {
    value: "JO_962",
    name: "Jordan",
    isoCode: "JO",
    countryCode: "962",
  },
  {
    value: "KZ_7",
    name: "Kazakhstan",
    isoCode: "KZ",
    countryCode: "7",
  },
  {
    value: "KE_254",
    name: "Kenya",
    isoCode: "KE",
    countryCode: "254",
  },
  {
    value: "KI_686",
    name: "Kiribati",
    isoCode: "KI",
    countryCode: "686",
  },
  {
    value: "XK_383",
    name: "Kosovo",
    isoCode: "XK",
    countryCode: "383",
  },
  {
    value: "KW_965",
    name: "Kuwait",
    isoCode: "KW",
    countryCode: "965",
  },
  {
    value: "KG_996",
    name: "Kyrgyzstan",
    isoCode: "KG",
    countryCode: "996",
  },
  {
    value: "LA_856",
    name: "Laos",
    isoCode: "LA",
    countryCode: "856",
  },
  {
    value: "LV_371",
    name: "Latvia",
    isoCode: "LV",
    countryCode: "371",
  },
  {
    value: "LB_961",
    name: "Lebanon",
    isoCode: "LB",
    countryCode: "961",
  },
  {
    value: "LS_266",
    name: "Lesotho",
    isoCode: "LS",
    countryCode: "266",
  },
  {
    value: "LR_231",
    name: "Liberia",
    isoCode: "LR",
    countryCode: "231",
  },
  {
    value: "LY_218",
    name: "Libya",
    isoCode: "LY",
    countryCode: "218",
  },
  {
    value: "LI_423",
    name: "Liechtenstein",
    isoCode: "LI",
    countryCode: "423",
  },
  {
    value: "LT_370",
    name: "Lithuania",
    isoCode: "LT",
    countryCode: "370",
  },
  {
    value: "LU_352",
    name: "Luxembourg",
    isoCode: "LU",
    countryCode: "352",
  },
  {
    value: "MO_853",
    name: "Macau",
    isoCode: "MO",
    countryCode: "853",
  },
  {
    value: "MK_389",
    name: "Macedonia",
    isoCode: "MK",
    countryCode: "389",
  },
  {
    value: "MG_261",
    name: "Madagascar",
    isoCode: "MG",
    countryCode: "261",
  },
  {
    value: "MW_265",
    name: "Malawi",
    isoCode: "MW",
    countryCode: "265",
  },
  {
    value: "MY_60",
    name: "Malaysia",
    isoCode: "MY",
    countryCode: "60",
  },
  {
    value: "MV_960",
    name: "Maldives",
    isoCode: "MV",
    countryCode: "960",
  },
  {
    value: "ML_223",
    name: "Mali",
    isoCode: "ML",
    countryCode: "223",
  },
  {
    value: "MT_356",
    name: "Malta",
    isoCode: "MT",
    countryCode: "356",
  },
  {
    value: "MH_692",
    name: "Marshall Islands",
    isoCode: "MH",
    countryCode: "692",
  },
  {
    value: "MR_222",
    name: "Mauritania",
    isoCode: "MR",
    countryCode: "222",
  },
  {
    value: "MU_230",
    name: "Mauritius",
    isoCode: "MU",
    countryCode: "230",
  },
  {
    value: "YT_262",
    name: "Mayotte",
    isoCode: "YT",
    countryCode: "262",
  },
  {
    value: "MX_52",
    name: "Mexico",
    isoCode: "MX",
    countryCode: "52",
  },
  {
    value: "FM_691",
    name: "Micronesia",
    isoCode: "FM",
    countryCode: "691",
  },
  {
    value: "MD_373",
    name: "Moldova",
    isoCode: "MD",
    countryCode: "373",
  },
  {
    value: "MC_377",
    name: "Monaco",
    isoCode: "MC",
    countryCode: "377",
  },
  {
    value: "MN_976",
    name: "Mongolia",
    isoCode: "MN",
    countryCode: "976",
  },
  {
    value: "ME_382",
    name: "Montenegro",
    isoCode: "ME",
    countryCode: "382",
  },
  {
    value: "MS_1664",
    name: "Montserrat",
    isoCode: "MS",
    countryCode: "1664",
  },
  {
    value: "MA_212",
    name: "Morocco",
    isoCode: "MA",
    countryCode: "212",
  },
  {
    value: "MZ_258",
    name: "Mozambique",
    isoCode: "MZ",
    countryCode: "258",
  },
  {
    value: "MM_95",
    name: "Myanmar",
    isoCode: "MM",
    countryCode: "95",
  },
  {
    value: "NA_264",
    name: "Namibia",
    isoCode: "NA",
    countryCode: "264",
  },
  {
    value: "NR_674",
    name: "Nauru",
    isoCode: "NR",
    countryCode: "674",
  },
  {
    value: "NP_977",
    name: "Nepal",
    isoCode: "NP",
    countryCode: "977",
  },
  {
    value: "NL_31",
    name: "Netherlands",
    isoCode: "NL",
    countryCode: "31",
  },
  {
    value: "AN_599",
    name: "Netherlands Antilles",
    isoCode: "AN",
    countryCode: "599",
  },
  {
    value: "NC_687",
    name: "New Caledonia",
    isoCode: "NC",
    countryCode: "687",
  },
  {
    value: "NZ_64",
    name: "New Zealand",
    isoCode: "NZ",
    countryCode: "64",
  },
  {
    value: "NI_505",
    name: "Nicaragua",
    isoCode: "NI",
    countryCode: "505",
  },
  {
    value: "NE_227",
    name: "Niger",
    isoCode: "NE",
    countryCode: "227",
  },
  {
    value: "NG_234",
    name: "Nigeria",
    isoCode: "NG",
    countryCode: "234",
  },
  {
    value: "NU_683",
    name: "Niue",
    isoCode: "NU",
    countryCode: "683",
  },
  {
    value: "KP_850",
    name: "North Korea",
    isoCode: "KP",
    countryCode: "850",
  },
  {
    value: "MP_1670",
    name: "Northern Mariana Islands",
    isoCode: "MP",
    countryCode: "1670",
  },
  {
    value: "NO_47",
    name: "Norway",
    isoCode: "NO",
    countryCode: "47",
  },
  {
    value: "OM_968",
    name: "Oman",
    isoCode: "OM",
    countryCode: "968",
  },
  {
    value: "PK_92",
    name: "Pakistan",
    isoCode: "PK",
    countryCode: "92",
  },
  {
    value: "PW_680",
    name: "Palau",
    isoCode: "PW",
    countryCode: "680",
  },
  {
    value: "PS_970",
    name: "Palestine",
    isoCode: "PS",
    countryCode: "970",
  },
  {
    value: "PA_507",
    name: "Panama",
    isoCode: "PA",
    countryCode: "507",
  },
  {
    value: "PG_675",
    name: "Papua New Guinea",
    isoCode: "PG",
    countryCode: "675",
  },
  {
    value: "PY_595",
    name: "Paraguay",
    isoCode: "PY",
    countryCode: "595",
  },
  {
    value: "PE_51",
    name: "Peru",
    isoCode: "PE",
    countryCode: "51",
  },
  {
    value: "PH_63",
    name: "Philippines",
    isoCode: "PH",
    countryCode: "63",
  },
  {
    value: "PN_64",
    name: "Pitcairn",
    isoCode: "PN",
    countryCode: "64",
  },
  {
    value: "PL_48",
    name: "Poland",
    isoCode: "PL",
    countryCode: "48",
  },
  {
    value: "PT_351",
    name: "Portugal",
    isoCode: "PT",
    countryCode: "351",
  },
  {
    value: "PR_1787",
    name: "Puerto Rico",
    isoCode: "PR",
    countryCode: "1787",
  },
  {
    value: "QA_974",
    name: "Qatar",
    isoCode: "QA",
    countryCode: "974",
  },
  {
    value: "CG_242",
    name: "Republic of the Congo",
    isoCode: "CG",
    countryCode: "242",
  },
  {
    value: "RE_262",
    name: "Reunion",
    isoCode: "RE",
    countryCode: "262",
  },
  {
    value: "RO_40",
    name: "Romania",
    isoCode: "RO",
    countryCode: "40",
  },
  {
    value: "RU_7",
    name: "Russia",
    isoCode: "RU",
    countryCode: "7",
  },
  {
    value: "RW_250",
    name: "Rwanda",
    isoCode: "RW",
    countryCode: "250",
  },
  {
    value: "BL_590",
    name: "Saint Barthelemy",
    isoCode: "BL",
    countryCode: "590",
  },
  {
    value: "SH_290",
    name: "Saint Helena",
    isoCode: "SH",
    countryCode: "290",
  },
  {
    value: "KN_1869",
    name: "Saint Kitts and Nevis",
    isoCode: "KN",
    countryCode: "1869",
  },
  {
    value: "LC_1758",
    name: "Saint Lucia",
    isoCode: "LC",
    countryCode: "1758",
  },
  {
    value: "MF_590",
    name: "Saint Martin",
    isoCode: "MF",
    countryCode: "590",
  },
  {
    value: "PM_508",
    name: "Saint Pierre and Miquelon",
    isoCode: "PM",
    countryCode: "508",
  },
  {
    value: "VC_1784",
    name: "Saint Vincent and the Grenadines",
    isoCode: "VC",
    countryCode: "1784",
  },
  {
    value: "WS_685",
    name: "Samoa",
    isoCode: "WS",
    countryCode: "685",
  },
  {
    value: "SM_378",
    name: "San Marino",
    isoCode: "SM",
    countryCode: "378",
  },
  {
    value: "ST_239",
    name: "Sao Tome and Principe",
    isoCode: "ST",
    countryCode: "239",
  },
  {
    value: "SA_966",
    name: "Saudi Arabia",
    isoCode: "SA",
    countryCode: "966",
  },
  {
    value: "SN_221",
    name: "Senegal",
    isoCode: "SN",
    countryCode: "221",
  },
  {
    value: "RS_381",
    name: "Serbia",
    isoCode: "RS",
    countryCode: "381",
  },
  {
    value: "SC_248",
    name: "Seychelles",
    isoCode: "SC",
    countryCode: "248",
  },
  {
    value: "SL_232",
    name: "Sierra Leone",
    isoCode: "SL",
    countryCode: "232",
  },
  {
    value: "SG_65",
    name: "Singapore",
    isoCode: "SG",
    countryCode: "65",
  },
  {
    value: "SX_1721",
    name: "Sint Maarten",
    isoCode: "SX",
    countryCode: "1721",
  },
  {
    value: "SK_421",
    name: "Slovakia",
    isoCode: "SK",
    countryCode: "421",
  },
  {
    value: "SI_386",
    name: "Slovenia",
    isoCode: "SI",
    countryCode: "386",
  },
  {
    value: "SB_677",
    name: "Solomon Islands",
    isoCode: "SB",
    countryCode: "677",
  },
  {
    value: "SO_252",
    name: "Somalia",
    isoCode: "SO",
    countryCode: "252",
  },
  {
    value: "ZA_27",
    name: "South Africa",
    isoCode: "ZA",
    countryCode: "27",
  },
  {
    value: "KR_82",
    name: "South Korea",
    isoCode: "KR",
    countryCode: "82",
  },
  {
    value: "SS_211",
    name: "South Sudan",
    isoCode: "SS",
    countryCode: "211",
  },
  {
    value: "ES_34",
    name: "Spain",
    isoCode: "ES",
    countryCode: "34",
  },
  {
    value: "LK_94",
    name: "Sri Lanka",
    isoCode: "LK",
    countryCode: "94",
  },
  {
    value: "SD_249",
    name: "Sudan",
    isoCode: "SD",
    countryCode: "249",
  },
  {
    value: "SR_597",
    name: "Suriname",
    isoCode: "SR",
    countryCode: "597",
  },
  {
    value: "SJ_47",
    name: "Svalbard and Jan Mayen",
    isoCode: "SJ",
    countryCode: "47",
  },
  {
    value: "SZ_268",
    name: "Swaziland",
    isoCode: "SZ",
    countryCode: "268",
  },
  {
    value: "SE_46",
    name: "Sweden",
    isoCode: "SE",
    countryCode: "46",
  },
  {
    value: "CH_41",
    name: "Switzerland",
    isoCode: "CH",
    countryCode: "41",
  },
  {
    value: "SY_963",
    name: "Syria",
    isoCode: "SY",
    countryCode: "963",
  },
  {
    value: "TW_886",
    name: "Taiwan",
    isoCode: "TW",
    countryCode: "886",
  },
  {
    value: "TJ_992",
    name: "Tajikistan",
    isoCode: "TJ",
    countryCode: "992",
  },
  {
    value: "TZ_255",
    name: "Tanzania",
    isoCode: "TZ",
    countryCode: "255",
  },
  {
    value: "TH_66",
    name: "Thailand",
    isoCode: "TH",
    countryCode: "66",
  },
  {
    value: "TG_228",
    name: "Togo",
    isoCode: "TG",
    countryCode: "228",
  },
  {
    value: "TK_690",
    name: "Tokelau",
    isoCode: "TK",
    countryCode: "690",
  },
  {
    value: "TO_676",
    name: "Tonga",
    isoCode: "TO",
    countryCode: "676",
  },
  {
    value: "TT_1868",
    name: "Trinidad and Tobago",
    isoCode: "TT",
    countryCode: "1868",
  },
  {
    value: "TN_216",
    name: "Tunisia",
    isoCode: "TN",
    countryCode: "216",
  },
  {
    value: "TR_90",
    name: "Turkey",
    isoCode: "TR",
    countryCode: "90",
  },
  {
    value: "TM_993",
    name: "Turkmenistan",
    isoCode: "TM",
    countryCode: "993",
  },
  {
    value: "TC_1649",
    name: "Turks and Caicos Islands",
    isoCode: "TC",
    countryCode: "1649",
  },
  {
    value: "TV_688",
    name: "Tuvalu",
    isoCode: "TV",
    countryCode: "688",
  },
  {
    value: "VI_1340",
    name: "U.S. Virgin Islands",
    isoCode: "VI",
    countryCode: "1340",
  },
  {
    value: "UG_256",
    name: "Uganda",
    isoCode: "UG",
    countryCode: "256",
  },
  {
    value: "UA_380",
    name: "Ukraine",
    isoCode: "UA",
    countryCode: "380",
  },
  {
    value: "AE_971",
    name: "United Arab Emirates",
    isoCode: "AE",
    countryCode: "971",
  },
  {
    value: "US_1",
    name: "United States",
    isoCode: "US",
    countryCode: "1",
  },
  {
    value: "GB_44",
    name: "United Kingdom",
    isoCode: "GB",
    countryCode: "44",
  },
  {
    value: "UY_598",
    name: "Uruguay",
    isoCode: "UY",
    countryCode: "598",
  },
  {
    value: "UZ_998",
    name: "Uzbekistan",
    isoCode: "UZ",
    countryCode: "998",
  },
  {
    value: "VU_678",
    name: "Vanuatu",
    isoCode: "VU",
    countryCode: "678",
  },
  {
    value: "VA_379",
    name: "Vatican",
    isoCode: "VA",
    countryCode: "379",
  },
  {
    value: "VE_58",
    name: "Venezuela",
    isoCode: "VE",
    countryCode: "58",
  },
  {
    value: "VN_84",
    name: "Vietnam",
    isoCode: "VN",
    countryCode: "84",
  },
  {
    value: "WF_681",
    name: "Wallis and Futuna",
    isoCode: "WF",
    countryCode: "681",
  },
  {
    value: "EH_212",
    name: "Western Sahara",
    isoCode: "EH",
    countryCode: "212",
  },
  {
    value: "YE_967",
    name: "Yemen",
    isoCode: "YE",
    countryCode: "967",
  },
  {
    value: "ZM_260",
    name: "Zambia",
    isoCode: "ZM",
    countryCode: "260",
  },
  {
    value: "ZW_263",
    name: "Zimbabwe",
    isoCode: "ZW",
    countryCode: "263",
  },
];

export const currencyList = [
  {
    ISOCode: "INR",
    symbol: "Rs",
    currencyName: "Indian Rupee",
    decimalCurrencyName: "Paisa",
  },
  {
    ISOCode: "USD",
    symbol: "$",
    currencyName: "U.S. Dollar",
    decimalCurrencyName: "Cent",
  },
  {
    ISOCode: "GBP",
    symbol: "£",
    currencyName: "British Pound",
    decimalCurrencyName: "Penny",
  },
  {
    ISOCode: "SGD",
    symbol: "S$",
    currencyName: "Singapore Dollar",
    decimalCurrencyName: "Cent",
  },
  {
    ISOCode: "AUD",
    symbol: "A$",
    currencyName: "Australian Dollar",
    decimalCurrencyName: "Cent",
  },
  {
    ISOCode: "EUR",
    symbol: "€",
    currencyName: "Euro",
    decimalCurrencyName: "Cent",
  },
  {
    ISOCode: "NZD",
    symbol: "N$",
    currencyName: "New Zealand Dollar",
    decimalCurrencyName: "Cent",
  },
  {
    ISOCode: "THB",
    symbol: "฿",
    currencyName: "Thai Baht",
    decimalCurrencyName: "Satang",
  },
  {
    ISOCode: "MYR",
    symbol: "RM",
    currencyName: "Malaysian Ringgit",
    decimalCurrencyName: "Sen",
  },
  {
    ISOCode: "HKD",
    symbol: "HK$",
    currencyName: "Hong Kong Dollar",
    decimalCurrencyName: "Cent",
  },
  {
    ISOCode: "CNY",
    symbol: "¥",
    currencyName: "Chinese Yuán",
    decimalCurrencyName: "Fen",
  },
  {
    ISOCode: "JPY",
    symbol: "¥",
    currencyName: "Japanese Yen",
    decimalCurrencyName: "Sen",
  },
  {
    ISOCode: "CHF",
    symbol: "CHF",
    currencyName: "Swiss Franc",
    decimalCurrencyName: "Centime",
  },
  {
    ISOCode: "AED",
    symbol: "AED",
    currencyName: "Arab Emirates Dirham",
    decimalCurrencyName: "Fils",
  },
  {
    ISOCode: "KRW",
    symbol: "₩",
    currencyName: "South Korean Won",
    decimalCurrencyName: "Jeon",
  },
  {
    ISOCode: "ZAR",
    symbol: "R",
    currencyName: "South African Rand",
    decimalCurrencyName: "Cent",
  },
  {
    ISOCode: "IRR",
    symbol: "ریال",
    currencyName: "Iranian Rial",
    decimalCurrencyName: "Dinar",
  },
  {
    ISOCode: "ARS",
    symbol: "$",
    currencyName: "Argentine Peso",
    decimalCurrencyName: "Centavos",
  },
  {
    ISOCode: "BHD",
    symbol: "BD",
    currencyName: "Bahraini Dinar",
    decimalCurrencyName: "Fils",
  },
  {
    ISOCode: "KWD",
    symbol: "KD",
    currencyName: "Kuwaiti Dinar",
    decimalCurrencyName: "Fils",
  },
  {
    ISOCode: "IDR",
    symbol: "Rp",
    currencyName: "Indonesian Rupiah",
    decimalCurrencyName: "Paisa",
  },
  {
    ISOCode: "CAD",
    symbol: "C$",
    currencyName: "Canadian Dollar",
    decimalCurrencyName: "Cent",
  },
  {
    ISOCode: "VEB",
    symbol: "Bs.",
    currencyName: "Venezuelan bolivars",
    decimalCurrencyName: "Céntimo",
  },
  {
    ISOCode: "NGN",
    symbol: "₦",
    currencyName: "Nigerian naira",
    decimalCurrencyName: "kobo",
  },
  {
    ISOCode: "DKK",
    symbol: "kr.",
    currencyName: "Danish krone",
    decimalCurrencyName: "øre",
  },
  {
    ISOCode: "NAD",
    symbol: "N$",
    currencyName: "Namibian Dollar",
    decimalCurrencyName: "cent",
  },
  {
    ISOCode: "VND",
    symbol: "VND",
    currencyName: "Vietnamese dong",
    decimalCurrencyName: "xu",
  },
  {
    ISOCode: "DOP",
    symbol: "$",
    currencyName: "Dominican peso",
    decimalCurrencyName: "centavo",
  },
  {
    ISOCode: "MXN",
    symbol: "MXN $",
    currencyName: "Mexican peso",
    decimalCurrencyName: "centavo",
  },
  {
    ISOCode: "BRL",
    symbol: "R$",
    currencyName: "Brazilian real",
    decimalCurrencyName: "centavo",
  },
  {
    ISOCode: "BDT",
    symbol: "BDT",
    currencyName: "Bangladeshi taka",
    decimalCurrencyName: "poisha",
  },
  {
    ISOCode: "ROL",
    symbol: "RON",
    currencyName: "Romanian leu",
    decimalCurrencyName: "ban",
  },
  {
    ISOCode: "TND",
    symbol: "TND",
    currencyName: "Tunisian dinar",
    decimalCurrencyName: "milim",
  },
  {
    ISOCode: "LYD",
    symbol: "LYD",
    currencyName: "Libyan dinar",
    decimalCurrencyName: "dirham",
  },
  {
    ISOCode: "SAR",
    symbol: "SAR ",
    currencyName: "Saudi riyal",
    decimalCurrencyName: "halal a",
  },
  {
    ISOCode: "CLP",
    symbol: "$",
    currencyName: "Chilean peso",
    decimalCurrencyName: "pesos",
  },
  {
    ISOCode: "PKR",
    symbol: "Rs.",
    currencyName: "Pakistani rupee",
    decimalCurrencyName: "Paisa",
  },
  {
    ISOCode: "PHP",
    symbol: "PHP",
    currencyName: "Philippine peso",
    decimalCurrencyName: "sentimo",
  },
  {
    ISOCode: "COP",
    symbol: "$",
    currencyName: "Colombian peso",
    decimalCurrencyName: "centavo",
  },
  {
    ISOCode: "HRK",
    symbol: "kn",
    currencyName: "Croatian kuna",
    decimalCurrencyName: "lipa",
  },
  {
    ISOCode: "ALL",
    symbol: "L",
    currencyName: "Albanian lek",
    decimalCurrencyName: "qindarkë",
  },
  {
    ISOCode: "EGP",
    symbol: "E£",
    currencyName: "Egyptian pound",
    decimalCurrencyName: "Piastre",
  },
  {
    ISOCode: "RUB",
    symbol: "py6",
    currencyName: "Russian ruble",
    decimalCurrencyName: "kopeyka",
  },
  {
    ISOCode: "MUR",
    symbol: "₨",
    currencyName: "Mauritian Rupee",
    decimalCurrencyName: "Cent",
  },
  {
    ISOCode: "QAR",
    symbol: "ر.ق",
    currencyName: "Qatari riyal",
    decimalCurrencyName: "dirham",
  },
  {
    ISOCode: "DZD",
    symbol: "دج",
    currencyName: "Algerian Dinar",
    decimalCurrencyName: "Santeem",
  },
  {
    ISOCode: "MMK",
    symbol: "K",
    currencyName: "Burmese Kyat",
    decimalCurrencyName: "Pya",
  },
  {
    ISOCode: "UAH",
    symbol: "₴",
    currencyName: "Ukrainian Hryvnia",
    decimalCurrencyName: "Kopiyka",
  },
  {
    ISOCode: "NOK",
    symbol: "kr",
    currencyName: "Norwegian Krone",
    decimalCurrencyName: "kr",
  },
  {
    ISOCode: "KES",
    symbol: "KSh",
    currencyName: "Kenyan shilling",
    decimalCurrencyName: "cent",
  },
];

export const paymentMode = [
  { value: "Cash", name: "Cash" },
  { value: "Cheque", name: "Cheque" },
  { value: "Online", name: "Online" },
  { value: "CreditCard", name: "Credit Card" },
  { value: "DebitCard", name: "Debit Card" },
];
